import palette from '@lib/core/src/theme/palette';
import { Stack, styled } from '@mui/material';

export const PageContainer = styled(Stack)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100vh',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: palette.grey[100]
});
